/**
 * Shared Gamma presentation step for Path A (positions) and Path B (full beta).
 */
import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import type { AuthSession } from '../../../../types/plans'
import type { ConstructorPlan } from '../constructorTypes'
import { GammaPhotoPickerPanel } from './GammaPhotoPickerPanel'
import { WORKFLOW_CHECKPOINT_KEYS } from '../workflowCheckpoint'

function getSavedGammaPresentations(planDetail: ConstructorPlan): unknown[] {
  const checkpoint = planDetail.workflow_checkpoints?.[WORKFLOW_CHECKPOINT_KEYS.gammaPresentation]
  return Array.isArray(checkpoint?.presentations) ? checkpoint.presentations : []
}

export function GammaPresentationStep({
  bootstrap,
  session,
  planDetail,
  misPatientId,
}: {
  bootstrap: TenantBootstrapModel
  session: AuthSession
  planDetail: ConstructorPlan
  misPatientId: string | null
}) {
  const planId = planDetail.mis_plan_id ?? String(planDetail.id)
  const savedPresentations = getSavedGammaPresentations(planDetail)
  if (!misPatientId) {
    return (
      <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900">
        Привяжите пациента к MIS, чтобы выбрать фото NAS для Gamma.
      </p>
    )
  }

  return (
    <div className="h-full min-h-[480px]">
      <GammaPhotoPickerPanel
        bootstrap={bootstrap}
        session={session}
        misPatientId={misPatientId}
        planId={planId}
        constructorPlanId={planDetail.id || null}
        initialPresentations={savedPresentations as never}
      />
    </div>
  )
}
